import { createContext, FC, useCallback, useContext, useState } from 'react';
import { Toast } from '../../../components/molecules/Toast';

import type { ToastContextType, ToastProviderProps, ToastShowParams, ToastState } from './ToastContext.types';

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToastContext = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToastContext must be used within a ToastProvider');
    }
    return context;
};

export const ToastProvider: FC<ToastProviderProps> = ({ children }) => {
    const [toast, setToast] = useState<ToastState>({
        message: null,
        error: false,
        success: false
    });

    const showToast = useCallback((
        { message, error = false, success = false }: ToastShowParams) => {
        setToast({ message, error, success });
    }, []);

    const hideToast = useCallback(() => {
        setToast({ message: null, error: false, success: false });
    }, []);

    const clearToastState = () => {
        hideToast();
    };

    return (
        <ToastContext.Provider value={{ showToast, hideToast }}>
            <Toast {...toast} onDismiss={clearToastState} />
            {children}
        </ToastContext.Provider>
    );
};